var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenExternal = function SvgOpenExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4H6.25A2.25 2.25 0 0 0 4 6.25v11.5A2.25 2.25 0 0 0 6.25 20h11.5A2.25 2.25 0 0 0 20 17.75V13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 4.698 15.76 8.24l-2.656 2.656M15.757 4H20M20 4v4.242"
  })));
};
export default SvgOpenExternal;